import { createFileRoute, notFound } from "@tanstack/react-router";
import { CatalogChildPage } from "@/components/sections/catalog-pages";
import { getCatalogChild } from "@/lib/services-catalog";

export const Route = createFileRoute("/services/pos-software/$child")({
  component: PosSoftwareChild,
  head: ({ params }) => {
    const found = getCatalogChild("pos-software", params.child);
    const title = found ? `${found.item.title} — POS Software — CoderLity` : "POS Software — CoderLity";
    const desc = found?.item.desc ?? "Retail & restaurant POS.";
    return {
      meta: [
        { title },
        { name: "description", content: desc },
        { property: "og:title", content: title },
        { property: "og:description", content: desc },
        { property: "og:url", content: `/services/pos-software/${params.child}` },
      ],
      links: [{ rel: "canonical", href: `https://coderlity.com/services/pos-software/${params.child}` }],
    };
  },
});

function PosSoftwareChild() {
  const { child } = Route.useParams();
  const found = getCatalogChild("pos-software", child);
  if (!found) throw notFound();
  return <CatalogChildPage cat={found.cat} item={found.item} />;
}
